module.exports = __webpack_public_path__ + "img/TFM-F.0a089dfb.gif";